module.exports = __webpack_public_path__ + "img/silver.e0a3699a.png";